

































































































































import {
  apiOrderOrderCancel,
  apiOrderOrderPay,
  ApiOrderWriteOffOrderListResponse,
} from '@/api'
import { computed } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'
import { Dialog } from 'vant'
import { globalModel } from '@/model'
import { ItemOf, submit } from '@/utils'
import { navigateTo } from '@/router'

export default defineClassComponent<{
  value: ItemOf<ApiOrderWriteOffOrderListResponse>
  fromDetail: boolean
}>(
  {
    props: ['value', 'fromDetail'],
  },
  ({ props, ctx }) =>
    class {
      // 订单状态
      status = computed(() => props.value.status)

      // 是否组合订单
      isJoint = computed(() => props.value.orderClassify === 5)

      // 点击取消订单
      handleCancelClick = () => {
        submit(async $ => {
          await Dialog.confirm({
            title: '温馨提示',
            message: '确定取消此订单吗？',
          })
          await $.start()
          await apiOrderOrderCancel({
            orderNo: props.value.orderNo,
          })
          ctx.$emit('refresh')
          navigateTo('OrderCancelResult')
        })
      }

      // 去支付
      handlePayClick = () => {
        submit(async $ => {
          await $.start()
          const payData = await apiOrderOrderPay({
            orderNo: props.value.orderNo,
            payType: globalModel.state.payType as any,
            openId: globalModel.state.openid,
          })
          await dcb.requestPayment({
            provider: 'native',
            showNativeResultPage: false,
            params: payData,
          })
          ctx.$emit('refresh')
          await $.success('支付成功')
        })
      }

      // 申请退款
      handleRequestRefundClick = () => {
        navigateTo('BookRefundRequest', {
          orderNo: props.value.orderNo,
        })
      }

      // 查看详情
      handleDetailClick = () => {
        navigateTo('BookOrderDetail', {
          orderNo: props.value.orderNo,
        })
      }

      // 去评价
      handleCommentClick = () => {
        navigateTo('BookCommentAdd', {
          orderNo: props.value.orderNo,
        })
      }

      // 再来一单
      handleAgainClick = () => {
        navigateTo(
          props.value.orderClassify === 5
            ? 'JointGoodsIndex'
            : 'BookGoodsIndex',
          {
            goodsId: props.value.commodityId,
          },
        )
      }

      // 退款进度
      handleRefundClick = () => {
        navigateTo('BookRefundResult', {
          refundId: props.value.orderNo,
        })
      }
    },
)
